<template>
  <div class="menu" ref="menu">
    <template v-for="(item, index) in data">
      <div class="menu__item" v-if="item.showItem && !item.children" :key="index">
        <router-link
          class="menu__item-link"
          :to="item.name"
          @click.native="emitHideMenu"
          exact
        >
          <span class="material-icons icon-image-preview">
             {{ item.icon }}
          </span>
          <div class="menu__item-text" v-if="!short">{{ item.label }}</div>
        </router-link>
      </div>
      <MenuWithTree
        v-if="item.showItem && item.children"
        :short="short"
        :item="item"
        :menu="menu"
        :classActiveMenu="classes.activeMenu"
        :key="index"
        @toggleShowModal="toggleShowModal"
      />
    </template>
  </div>
</template>

<script>
import clickOutside from 'v-click-outside'
const MenuWithTree = () => import('@components/Menu/MenuWithTree.vue')

export default {
  directives: {
    'clickOutside': clickOutside.directive
  },
  components: { MenuWithTree },
  props: {
    data: {
      type: Object
    },
    short: {
      type: Boolean
    }
  },
  data () {
    return {
      menu: {
        showItem: '',
        activeParentItem: ''
      },
      classes: {
        activeMenu: 'menu__item-dropdown__active',
        activeShortMenu: 'menu__item-dropdown_short-active',
        dropdownShort: 'menu__item-dropdown_short'
      }
    }
  },
  watch: {
    data: function () {
      this.initShowSubMenu(this.$route)
    },
    short: function () {
      this.menu.showItem = ''
      // this.$nextTick(() => {
      //   this.setPositionModal()
      // })
    },
    $route (to, from) {
      this.initShowSubMenu(to)
    }
  },
  created () {
    this.$event.$on('menu-hide', this.hideMenu)
  },
  methods: {
    findDeepChildren (route, data, parent, callback) {
      for (let childrenItem in data) {
        if (data[childrenItem].name === route.path) {
          callback(parent)
          break
        }
        if (data[childrenItem].children) {
          this.findDeepChildren(route, data[childrenItem].children, parent, callback)
        }
      }
    },
    initShowSubMenu (route) {
      for (let item in this.data) {
        if (this.data[item].children) {
          let children = this.data[item].children
          this.findDeepChildren(route, children, this.data[item], (parent) => {
            this.setActiveParentItem(parent.name)
          })
        } else {
          this.setActiveParentItem('')
        }
      }
    },
    setActiveParentItem (name) {
      this.menu.activeParentItem = name
    },
    // handleHideDrop () {
    //   this.hideMenu()
    // },
    emitHideMenu () {
      this.$event.$emit('menu-hide')
    },
    hideMenu () {
      this.menu.showItem = ''
    },
    setPositionModal () {
      const containerActive = this.$refs['menu'].querySelector(`.${this.classes.activeShortMenu}`)

      if (!containerActive) return

      const containerMenuChild = containerActive.querySelector(`.${this.classes.dropdownShort}`)

      const containerActiveHeight = containerActive.offsetHeight
      const containerMenuChildHeight = containerMenuChild.offsetHeight
      const windowHeight = window.outerHeight

      let containerOffsetTop = containerActive.offsetTop

      const isBiggestContainer = (containerMenuChildHeight + containerOffsetTop + 100) > windowHeight

      if (isBiggestContainer) {
        containerOffsetTop -= containerMenuChildHeight - containerActiveHeight
      }

      containerMenuChild.style.top = `${containerOffsetTop}px`
    },

    toggleShowModal (name) {
      if (this.menu.showItem === name) {
        this.menu.showItem = ''
        return
      }

      this.menu.showItem = name
      setTimeout(() => {
        this.setPositionModal()
      }, 1)
    }
  },
  beforeDestroy () {
    this.$event.$off('menu-hide', this.hideMenu)
  }
}
</script>
